import React from 'react';
import {
  Dialog,
  DialogContent,
  CircularProgress,
  Typography
} from '@mui/material';

const LoadingOverlay = ({ open = true, message = 'Loading...' }) => {
  return (
    <Dialog
      open={open}
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      }}
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
      }}
    >
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center', 
          justifyContent: 'center',
          backgroundColor: 'white',
          borderRadius: 2,
          minWidth: 200,
          minHeight: 120,
          textAlign: 'center'
        }}
      >
        <CircularProgress size={40} sx={{ mb: 2 }} />
        <Typography variant="body1" color="text.primary">
          {message}
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default LoadingOverlay;